/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tooltip_VaultInputs */

const en_tooltip_vault = /** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Vault allows you to store sensitive documents, paywalled content, and premium digital files. Buyers only get access after completing the purchase.`)
};

const id_tooltip_vault = /** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault memungkinkan Anda menyimpan dokumen rahasia, konten paywall, dan file digital premium. Pembeli hanya mendapatkan akses setelah menyelesaikan pembelian.`)
};

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const es_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const fr_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const de_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const ja_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const zh_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const ar_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const it_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const ru_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const pt_tooltip_vault = en_tooltip_vault;

/** @type {(inputs: Tooltip_VaultInputs) => LocalizedString} */
const ko_tooltip_vault = en_tooltip_vault;

/**
* | output |
* | --- |
* | "The Vault allows you to store sensitive documents, paywalled content, and premium digital files. Buyers only get access after completing the purchase." |
*
* @param {Tooltip_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tooltip_vault = /** @type {((inputs?: Tooltip_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tooltip_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tooltip_vault(inputs)
	if (locale === "es") return es_tooltip_vault(inputs)
	if (locale === "fr") return fr_tooltip_vault(inputs)
	if (locale === "de") return de_tooltip_vault(inputs)
	if (locale === "ja") return ja_tooltip_vault(inputs)
	if (locale === "zh") return zh_tooltip_vault(inputs)
	if (locale === "ar") return ar_tooltip_vault(inputs)
	if (locale === "id") return id_tooltip_vault(inputs)
	if (locale === "it") return it_tooltip_vault(inputs)
	if (locale === "ru") return ru_tooltip_vault(inputs)
	if (locale === "pt") return pt_tooltip_vault(inputs)
	return ko_tooltip_vault(inputs)
});